/**
 * @generated SignedSource<<8ef68162e209edffe2bee8ee3a72a9bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFacilityCourseNoun_facility$data = {
  readonly copyOverrides: {
    readonly course: {
      readonly plural: string;
      readonly singular: string;
    } | null | undefined;
  };
  readonly " $fragmentType": "useFacilityCourseNoun_facility";
};
export type useFacilityCourseNoun_facility$key = {
  readonly " $data"?: useFacilityCourseNoun_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFacilityCourseNoun_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFacilityCourseNoun_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FacilityCopyOverrides",
      "kind": "LinkedField",
      "name": "copyOverrides",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NounOverride",
          "kind": "LinkedField",
          "name": "course",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "singular",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plural",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "eb3a74b5a8f494fe96295d37fa238ea0";

export default node;
